import Config from '../config.json';
import { PathParams } from './odUtil';

export const urlUtil = (
  zustaendigeStelleBaseId: string,
  onlineServiceId: string
) => {
  return `${
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  }/portal/a3start/${zustaendigeStelleBaseId}/verfahren/${onlineServiceId}`;
};

export const urlToOnlineServiceWithoutId = () => {
  return `${
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  }/go/a/`;
};

export const urlToOnlineService = (onlineServiceId: string) => {
  return `${urlToOnlineServiceWithoutId()}${onlineServiceId}`;
};

export const urlToGovosDektop = () =>
  (
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  ).concat('/portal/desktop/0');

export const urlToGovosStartApp = (startAppId: string | number) =>
  (
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  ).concat(`/portal/a3start/${startAppId}`);

export const urlToGovosVerfahren = (
  startAppId: string | number,
  verfahrenId: string | number
) =>
  (
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  ).concat(`/portal/a3start/${startAppId}/verfahren/${verfahrenId}`);

export const urlToGovosVerfahrenZustellweg = (
  startAppId: string | number,
  verfahrenId: string | number,
  serviceIndex: number
) =>
  `${urlToGovosVerfahren(startAppId, verfahrenId)}/delivery.config?serviceIdx=${serviceIndex}`;

/**
 * @param startAppId - ID der Startanwendung
 * @param processId - ID des Prozesses
 * @param templateVersionId - ID der Vorlageversion
 * @param dataVersionId - ID der Datenversion
 * @param formType - Formulartyp (dl = download, r = bearbeiten, preov = vorbefüllen, a = aktivieren, shap = abgenommen datenschutzhinweis)
 */
// ?vvid=100_1_4&vvsf=a&ev=0
export type VVFormType = 'dl' | 'r' | 'preov' | 'a' | 'shap';
export const urlToGovosVV = (
  startAppId: string | number,
  processId: string | number,
  templateVersionId: string,
  dataVersionId: string,
  formType: VVFormType
) =>
  (
    process.env.REACT_APP_GOVOS_BASE_URL || Config.REACT_APP_GOVOS_BASE_URL
  ).concat(
    `/portal/a3start/${startAppId}/vverfassung?vvid=${processId}_${templateVersionId}_${dataVersionId}&vvsf=${formType}&${PathParams.redirectTo}=${window.location.href}`
  );
